import service from "../request";
//获取用户剩余点数 以及权益过期时间
export const balance = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/account/balance",
    method: "get",
    data,
  });

// 获取当前用户剩余点数
export const getBalance = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/user-service/employeePoints/getAiPoints",
    method: "post",
    data,
  });

//获取个人定制微模型列表

export const microModelList = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/iyw-ai-net/api/LoraSettings/GetList",
    method: "post",
    data,
  });

//获取用户生成任务列表

export const taskList = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/iyw-ai-net/api/GenerateTask/GetList",
    method: "post",
    data,
  });
//删除任务或者图片
export const deteleTask = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/task/detele",
    method: "post",
    data,
  });

//微模型生成接口
export const generate = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/v2/generate",
    method: "post",
    data,
  });
//多通道任务列表
export const multiChannelTaskList = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/GetList",
    method: "post",
    data,
  });
//获取配置接口（尺寸，模型对应消耗点数等）
export const modelConfig = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/iyw-ai-net/api/ScaleConfig/GetList",
    method: "post",
    data,
  });

// 根据图片ID获取原图
export const getMateial = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/getMateial",
    method: "post",
    data,
  });

// 工单接口
export const RecvMsgParser = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/messagecenter/Message/RecvMsgParser",
    method: "post",
    data,
  });

// 工单接口
export const SendWeComGroupMsg = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/messagecenter/Message/SendWeComGroupMsg",
    method: "post",
    data,
  });

//获取任务详情
export const microTask = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/iyw-ai-net/api/GenerateTask/GetDetails",
    method: "post",
    data,
  });

//获取个人信息--没有菜单
export const getUserInfo = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/user-service/user/getInfo",
    method: "post",
    data,
  });

//获取个人信息--有菜单
export const getMyInfo = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/user-service/user/getMyInfo",
    method: "post",
    data,
  });

//权益信息
export const GetAuthList = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/member/api/v2/MemberAuth/GetAuthList",
    method: "post",
    data,
  });

//mj查看大图
export const upscale = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/upscale",
    method: "post",
    data,
  });

//mj重绘图片
export const variation = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/variation",
    method: "post",
    data,
  });

//mj重新生成
export const reset = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/reset",
    method: "post",
    data,
  });

//优化提示词
export const upgradePrompt = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/upgradePrompt",
    method: "post",
    data,
  });

//反推提示词
export const describe = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/chat/describe",
    method: "post",
    data,
  });
//重新生成
export const microRefresh = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/reset",
    method: "post",
    data,
  });
//检测图片
export const checkImage = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/checkImage",
    method: "post",
    data,
  });
//批量生成
export const batch = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/v2/batch",
    method: "post",
    data,
  });
//获取用户已经设置的图片
export const userCollect = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/userCollect",
    method: "post",
    data,
  });

// 新收藏列表接口
export const userCollections = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/userCollections",
    method: "post",
    data,
  });

//获取用户生成图片历史记录
export const collects = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/collects",
    method: "post",
    data,
  });
//设置喜欢
export const addCollect = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/addCollect",
    method: "post",
    data,
  });
//设置移除喜欢
export const removeCollect = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/removeCollect",
    method: "post",
    data,
  });

// 刷新token
export const refreshToken = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "sso/api/sso/web/renewToken?refreshToken=" + data,
    method: "get",
  });

//新建AI对话
export const createNewChat = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/createNewChat",
    method: "post",
    data,
  });

//发送AI对话
export const sendChat = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/chat",
    method: "post",
    data,
  });

//获取趋势信息
export const OptimizePrompt = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/trender/OptimizePrompt",
    method: "post",
    data,
  });

export const inpaintApi = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/commerce/inpaint",
    method: "post",
    data,
  });

// 获取行业、服务类型
export const getByKey = (params) =>
  service({
    aseURL: process.env.VUE_APP_DESIGN_BASE,
    url: "/account-search/basic/dict/getByKey",
    method: "get",
    params,
    saasToken: false,
  });

//获取微模型列表
export const LoraSettings = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/iyw-ai-net/api/LoraSettings/GetList",
    method: "post",
    data,
  });

export const getRecommendList = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/opensearch-service/apply/recommend/page",
    method: "post",
    data,
  });

export const getPatternModelList = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/opensearch-service/apply/getMyPatternApply",
    method: "post",
    data,
  });

export const getMyDesignApply = (data) =>
  service({
    aseURL: process.env.VUE_APP_API,
    url: "/opensearch-service/apply/getMyDesignApply",
    method: "post",
    data,
  });

export const recommendImgGenerate = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-application/faddish/generate",
    method: "post",
    data,
  });

//应用获取
export const getMyApply = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/opensearch-service/apply/getMyApply",
    method: "post",
    data,
  });

//搜索当前部门下成员
export const employeeDeptList = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/user-service/employee/employeeDeptList",
    method: "post",
    data,
  });

//搜索创意拓展历史记录
export const history = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/chat/history",
    method: "post",
    data,
  });

//获取趋势列表
export const GetTrendList = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/theme-activity/api/Trend/GetTrendList",
    method: "post",
    data,
  });

//获取趋势详情
export const GetTrendDetail = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/theme-activity/api/Activitys/GetActivityDetail",
    method: "post",
    data,
  });

//获取方案
export const designScheme = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/chat/designScheme",
    method: "post",
    data,
  });

//生成ai图
export const generateImage = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/designScheme/generateImage",
    method: "post",
    data,
  });

//策划生成列表
export const schemeList = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/designScheme/list",
    method: "post",
    data,
  });

//查询图片列表
export const searchGenerateResult = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/designScheme/searchGenerateResult",
    method: "post",
    data,
  });

//策划详情
export const schemeDetail = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/designScheme/detail",
    method: "post",
    data,
  });

//删除策划图片
export const deleteImage = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/designScheme/deleteImage",
    method: "post",
    data,
  });

//获取趋势列表
export const GetTrenderList = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "ai-chat/api/trender/GetTrenderList",
    method: "post",
    data,
  });

//删除趋势
export const removeTask = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "ai-chat/api/designScheme/deleteScheme",
    method: "post",
    data,
  });

//获取pdf
export const generatePdf = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "ai-chat/api/designScheme/generatePdf",
    method: "post",
    data,
  });

//获取视频列表
export const GetVideoList = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/iyw-ai-net/api/HelpVideo/GetVideoList",
    method: "post",
    data,
  });

// 删除对话
export const deleteChatHistory = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/dialogue/delete",
    method: "post",
    data,
  });

// 获取历史对话
export const getChatHistory = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/dialogue/list",
    method: "post",
    data,
  });

// 获取历史对话
export const GetThemeList = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/trender/GetThemeList",
    method: "post",
    data,
  });

// 设置推送需求
export const addShceme = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/customerRequirement/add",
    method: "post",
    data,
  });

// 获取推送列表
export const getPushList = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/customerRequirementPublish/getList",
    method: "post",
    data,
  });

// 修改推送标题
export const editTitle = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/customerRequirementPublish/editTitle",
    method: "post",
    data,
  });

// 需求列表
export const getNeedList = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/customerRequirement/getList",
    method: "post",
    data,
  });

// 关闭或打开需求
export const setClose = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/customerRequirement/setClose",
    method: "post",
    data,
  });

// 删除需求
export const deleteRequirement = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/customerRequirement/deleteRequirement",
    method: "post",
    data,
  });

// 推送详情
export const pushDetail = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/customerRequirementPublish/detail",
    method: "post",
    data,
  });

// 删除图片（批量）
export const deleteImages = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/customerRequirementPublish/deleteImages",
    method: "post",
    data,
  });

// 删除推送
export const deletePush = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/customerRequirementPublish/delete",
    method: "post",
    data,
  });

// 需求详情
export const getRequirementDetail = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/customerRequirement/detail",
    method: "post",
    data,
  });

// 需求详情
export const adoptImage = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/customerRequirement/adoptImage",
    method: "post",
    data,
  });

// 私有趋势列表
export const trenderList = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/customerTrender/trenderList",
    method: "post",
    data,
  });

// 添加私有趋势
export const addTrender = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/customerTrender/add",
    method: "post",
    data,
  });

// 删除私有趋势
export const deleteTrender = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/customerTrender/deleteTrender",
    method: "post",
    data,
  });

// 启用禁用私有趋势
export const setStatus = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/customerTrender/setStatus",
    method: "post",
    data,
  });

// 批量获取私有趋势进度
export const getProcess = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/customerTrender/getProcess",
    method: "post",
    data,
  });

// 委托设计导出pdf
export const agentGeneratePDF = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/customerRequirementPublish/generatePDF",
    method: "post",
    data,
  });

// 创建视频任务
export const videoGenerator = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/commerce/videoGenerator",
    method: "post",
    data,
  });

// 收藏列表
export const getCollectList = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/favourite/list",
    method: "post",
    data,
  });

// 方案（图片）收藏/取消
export const collectPlan = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-chat/api/favourite/set",
    method: "post",
    data,
  });

export const clothingUp = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/commerce/generalGenerate",
    method: "post",
    data,
  });

export const checkClothing = (data) =>
  service({
    headers: { securityKey: "test" },
    baseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/identifyClothes",
    method: "post",
    data,
  });

export const extractionTools = (data) =>
  service({
    headers: { securityKey: "test" },
    baseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/commerce/extraction",
    method: "post",
    data,
  });

export const toolsGenerateImage = (data) =>
  service({
    headers: { securityKey: "test" },
    baseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/commerce/g_tools_generate_image",
    method: "post",
    data,
  });

// 获取产品策划任务详情接口
export const GetMicromodelDetails = (data) =>
  service({
    headers: { securityKey: "test" },
    baseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/GetDetails",
    method: "post",
    data,
  });

// 获取委派设计任务详情接口
export const GetRequirementImageDetail = (data) =>
  service({
    headers: { securityKey: "test" },
    baseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/microModel/RequirementImageDetail",
    method: "post",
    data,
  });

export const modelScene = (data) =>
  service({
    baseURL: process.env.VUE_APP_API,
    url: "/ai-application/api/commerce/modelScene",
    method: "post",
    data,
  });

// 导出PDF
export const exportPDF = (data) =>
  service({
    baseURL: process.env.VUE_APP_PDF_EXPORT,
    url: "/api/generate_pdf/export-pdf",
    method: "post",
    data,
  });

//点击获取mask
export const generateMask = (data) =>
  service({
    baseURL: process.env.VUE_APP_PDF_EXPORT,
    url: "/api/generate_mask",
    method: "post",
    data,
  });
// 查询PDF导出状态
export const queryPDFExportStatus = (taskId) =>
  service({
    baseURL: process.env.VUE_APP_PDF_EXPORT,
    url: "/api/generate_pdf/query-pdf-export",
    method: "get",
    params: {
      task_id: taskId,
    },
  });

// 查询改图状态
export const queryImageEditStatus = (taskId) =>
  service({
    baseURL: process.env.VUE_APP_PDF_EXPORT,
    url: "/api/generate_pdf/query-image-edit",
    method: "get",
    params: {
      task_id: taskId,
    },
  });
